export const CONTENT_ALIGNMENT = 'contentAlignment';
export const CONTENT_ALIGNMENT_MOBILE = 'contentAlignmentMobile';
export const CONTENT_ALIGNMENT_PATH = `style.numbers.${CONTENT_ALIGNMENT}`;
export const CONTENT_ALIGNMENT_MOBILE_PATH = `style.numbers.${CONTENT_ALIGNMENT_MOBILE}`;
export const CONTENT_ALIGNMENTS = {
    left: 0,
    center: 1,
    right: 2,
};
export const CONTENT_ALIGNMENT_PARAM = {
    wixParam: CONTENT_ALIGNMENT,
    appSettingsPath: CONTENT_ALIGNMENT_PATH,
    defaultAlignment: CONTENT_ALIGNMENTS.left,
};
export const CONTENT_ALIGNMENT_MOBILE_PARAM = {
    wixParam: CONTENT_ALIGNMENT_MOBILE,
    appSettingsPath: CONTENT_ALIGNMENT_MOBILE_PATH,
    defaultAlignment: CONTENT_ALIGNMENTS.left,
};
//# sourceMappingURL=content-alignment.js.map